export default __webpack_public_path__ + "static/books-af1be6a3b9cec24fa94d3072b7cc0632.webp";